<template>
    <div>
      <v-container
        fluid
        class="pa-0 info-drawer"
      >
        <div class="pa-6">
          <h2 class="d-flex justify-space-between align center mb-1">
            Manage Brands
            <v-btn
              icon
              @click.stop="$store.commit('ui/drawer.right.toggle')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </h2>
          <v-row>
            <v-col
              cols="12"
              class="body-2 pt-0 grey--text text--darken-2 font-weight-medium mb-3 text-left"
            >
            Use the Add to DNM button to add a contact to Brand DNM list.
            </v-col>
          </v-row>
        </div>
        <v-tabs
          color="#03B6FC"
          height="30px"
          class=" info-drawer"
        >
          <v-tab class="body-2 ml-2 text--darken-2 font-weight-regular">
            Brands ({{ brandList.length + brandListUnsubscribed.length }})
          </v-tab>
          <v-tab-item>
            <v-divider />
            <v-text-field
              v-model="searchString"
              outlined
              class="pa-6 pb-0 text--grey"
              label="Search"
              prepend-inner-icon="search"
            />
            <div class="pa-6 pt-0 list-frame">
              <v-list
                subheader
                two-line
                flat
              >
                <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5">
                  <span class="white">  Subscribed ({{ filterItems(brandList).length }})</span>
                </div>
                <v-list-item-group
                  multiple
                >
                  <v-list-item
                    v-for="list in filterItems(brandList)"
                    :key="list.id"
                    :ripple="false"
                    class="pa-0"
                  >
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-content class="ml-20">
                        <v-list-item-title>{{ list.name }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="mr-2">
                        <v-btn
                          id="add-to-dnm" 
                          outlined
                          rounded x-small color="indigo"
                          v-model="defaultValueTrue" 
                          @click.prevent.stop="toggle_subscription_locally(list,false)"> Add to Do Not Mail </v-btn>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
  
              <v-list
                subheader
                two-line
                flat
              >
                <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5">
                  <span class="white">  Unsubscribed ({{ filterItems(brandListUnsubscribed).length }})</span>
                </div>
                <v-list-item-group
                  multiple
                >
                  <v-list-item
                    v-for="list in filterItems(brandListUnsubscribed)"
                    :key="list.id"
                    :ripple="false"
                    class="pa-0"
                  >
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-content class="ml-20">
                        <v-list-item-title>{{ list.name }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="mr-2">
                        <v-btn
                          id="remove-from-dnm"
                          outlined 
                          rounded 
                          x-small color="indigo" 
                          v-model="defaultValueFalse" 
                          @click.prevent.stop="toggle_subscription_locally(list,true)"> Remove from Do Not Mail </v-btn>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
          </v-tab-item>
        </v-tabs>
      </v-container>
    </div>
  </template>
<script>
import { $contacts } from '@/services'
export default {
    data () {
    return {
      contact_id: null,
      defaultValueTrue: true,
      defaultValueFalse: false,
      loading: false,
      searchString: '',
      brandList: [],
      brandListUnsubscribed: [],
    }
    },
    mounted () {
      this.contact_id = this.$route.params.contactId
      this.getAddedBrandsLists()
    },
    methods: {
    getAddedBrandsLists () {
      this.loading = true
      $contacts.getSubscribedBrands(this.contact_id).then(response => {
        this.brandList = response.data.data.subscribed_brands
        this.brandListUnsubscribed = response.data.data.unsubscribed_brands
        this.loading = false
      }).catch(error => {
        this.loading = false
      })
    },
    filterItems (presets) {
      return presets.filter(preset => {
        const regex = new RegExp('(' + this.searchString + ')', 'i')
        return preset.name.match(regex)
      })
    },
    toggle_subscription_locally (brand, add) {
      let index
      let params = {};
      if (add) {
        params = {
          status: 'active',
          brand_id: brand.id,
        }
        index = this.brandListUnsubscribed.findIndex(x => x.id === brand.id)
        this.brandList.push(...this.brandListUnsubscribed.splice(index, 1))          
      } else {
        params = {
          status: 'inactive',
          brand_id: brand.id,
        }
        index = this.brandList.findIndex(x => x.id === brand.id)
        this.brandListUnsubscribed.push(...this.brandList.splice(index, 1))
      }
      $contacts.toggleBrandSubscription(this.contact_id,params).then(response => {
        this.$store.commit('ui/snackbar', { message: response.data.data.message, type: 'success' })
        this.loading = false
        this.$root.reloadBrandsList()
        this.$root.reloadContactsList()
      }).catch(error => {
        this.loading = false
      })
    },
    
    },
}
</script>

<style scoped>
    .ml-20 {
        margin-left: 20px;
    }
</style>